// src/admin/views/PrizeListView.js
import moment from 'moment'
import { useEffect, useState, useMemo } from 'react'
import { FiPlus } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import PageHeader from '../components/PageHeader'
import { useAdminStore } from '../store/AdminStore'

const getPrizeTypeName = (type) => {
  const prizeOptions = [
    { key: 0, value: 'Low Net' },
    { key: 1, value: 'Pinshot' },
    { key: 2, value: 'League Champ' },
    { key: 3, value: 'Skin' },
    { key: 4, value: 'Other' },
  ]
  const found = prizeOptions.find(o => o.key === parseInt(type, 10))
  return found ? found.value : 'Unknown'
}

function PrizeListView() {
  const [prizeData, setPrizeData] = useState([])
  const [eventData, setEventData] = useState([])
  const orgName = useAdminStore((state) => state.orgName)
  const orgId = useAdminStore((state) => state.orgId)
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)

    if (orgId) {
      // Fetch events for date mapping
      apiClient.get(`/gskapi/event/org/${orgId}`)
        .then((response) => setEventData(response.data))
        .catch((error) => console.error('Error fetching event data:', error))

      // Fetch prizes
      apiClient.get(`/gskapi/prizes/org/${orgId}`)
        .then((response) => {
          // Sort prizes by date/custom criteria if needed
          setPrizeData(response.data)
        })
        .catch((error) => console.error('Error fetching prize data:', error))
    }
  }, [orgId, navigate])

  const getEventDate = (eventId) => {
    const event = eventData.find(e => e.eventId === eventId)
    return event ? moment(event.eventDate).format('YYYY-MM-DD') : 'Unknown Date'
  }

  const sortedPrizes = useMemo(() => {
    return [...prizeData].sort((a, b) => {
      const eventA = eventData.find(e => e.eventId === a.eventId)
      const eventB = eventData.find(e => e.eventId === b.eventId)
      const dateA = eventA ? eventA.eventDate : ''
      const dateB = eventB ? eventB.eventDate : ''
      if (dateA !== dateB) {
        return dateB.localeCompare(dateA)
      }
      return parseFloat(b.prizeMoney || 0) - parseFloat(a.prizeMoney || 0)
    })
  }, [prizeData, eventData])

  return (
    <>
      <PageHeader backTo={'/admin'} pageName={'Prizes'} />
      {orgName && (
        <div style={{ textAlign: 'center', fontWeight: 'bold', margin: '10px 0' }}>
          {orgName}
        </div>
      )}
      <div className="add-button-container" style={{ marginTop: '20px' }}>
        <button className="btn btn-primary" onClick={() => navigate(`/admin/prize`)}>
          <FiPlus style={{ marginRight: '8px' }} /> Add Prize
        </button>
      </div>
      <div className="admin-list">
        {sortedPrizes.map((prize) => (
          <div
            key={prize.prizeId || `${prize.roundId}-${prize.prizeType}`}
            className="admin-list-item"
            style={{ display: 'flex', justifyContent: 'space-between', paddingRight: '20px', cursor: 'pointer' }}
            onClick={() => {
              if (prize.prizeId) {
                navigate(`/admin/prize?prizeId=${prize.prizeId}`)
              } else {
                console.log('Prize ID not found:', prize)
              }
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span className="admin-list-item-name">
                {getEventDate(prize.eventId)} - {prize.golferName}
              </span>
              <span style={{ fontSize: '14px', color: '#666' }}>
                {getPrizeTypeName(prize.prizeType)} - ${parseFloat(prize.prizeMoney || 0).toFixed(2)}
              </span>
            </div>
          </div>
        ))}
        {sortedPrizes.length === 0 && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            No prizes found.
          </div>
        )}
      </div>
    </>
  )
}

export default PrizeListView
